import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MapState {
  markerInfoWindowState: any;
  zoom: number;
  center: { lat: number; lng: number };
}

const initialState: MapState = {
  markerInfoWindowState: {},
  zoom: 12,
  center: { lat: 51.512275, lng: -0.116572 }
};

const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    toggleInfoWindow(
      state,
      { payload: { key, open } }: PayloadAction<{ key: string; open?: boolean }>
    ) {
      state.markerInfoWindowState[key] =
        open || !state.markerInfoWindowState[key];
    },
    setZoom(state, { payload }: PayloadAction<number>) {
      state.zoom = payload;
    },
    setCenter(state, { payload }: PayloadAction<UserLocation>) {
      state.center = payload;
    }
  }
});
const { actions, reducer } = mapSlice;
export const { toggleInfoWindow, setZoom, setCenter } = actions;
export default reducer;
export * from "./selectors";
